<template>
  <dropdown
    v-model="input"
    :editable="editable"
    type="time"
    v-bind="$props"
    :input-class="inputClass"
    :options="times()"
    @input="$emit('input', input)"
    @saved-to-db="$emit('saved-to-db')"
  />
</template>

<script>
import Dropdown from './Dropdown'
import moment from 'moment-timezone'
import Constants from '@/components/Constants'

export default {
  components: {
    Dropdown,
  },
  mixins: [Constants],
  props: {
    value: String,
    inputClass: String,
    editable: { type: Boolean, default: true },
    count: { type: Number, default: 48 },
  },
  data() {
    return {
      is24h: this.$store.state.userSettings['is-24h'],
      input: moment(this.value, ['HH:mm']).locale(navigator.language).format('LT'),
      countryCode: 'GB',
    }
  },
  created() {
    let timezone = this.$store.state.userSettings['timezone'] || moment.tz.guess()
    this.countryCode = this.$store.state.timezonesGlobal.find((x) => x.value === timezone).countryCode
    if (this.is24h === undefined) {
      this.input = moment(this.value, 'HH:mm').locale(this.countryCode).format('LT')
    } else {
      this.input = this.is24h ? this.value : moment(this.value, 'HH:mm').format('h:mm A')
    }
  },
  methods: {
    times: function () {
      return this.hoursFormatWithFractions(this.is24h, 2)
    },
  },
}
</script>
